import React from "react";
import BannerImg from "../../assets/Images/banner-img.webp";
import MobBannerImg from "../../assets/Images/banner-mob-img.webp";
import "./Banner.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import 'react-lazy-load-image-component/src/effects/blur.css';

function Banner() {
  return (
    <div className="banner">
      <div className="container-lg">
        <div className="row">
          <div className="col-lg-4 col-md-6 col-xs-12 col-sm-12">
              <div className="img-holder">
                <LazyLoadImage className="desktop-banner" src={BannerImg} effect="blur" alt="#" />
                <LazyLoadImage className="mob-banner" src={MobBannerImg} effect="blur" alt="#" />
              </div>
            </div>
          <div className="col-lg-8 col-md-6 col-xs-12 col-sm-12">
              <div className="text-holder">
                <div className="head-sec">
                  <h2 className="title">
                    <strong>Hey! I’m Nouman. </strong>
                    <span>Sr.Head of Experience & Design at </span>
                    NAHDI Medical Company
                  </h2>
                  <ul>
                    <li>Retail App - Asia award Winner 2025.</li>
                    <li>design leader.</li>
                    <li>product design mentor.</li>
                    <li>GCC Omnichannel experience award winner.</li>
                  </ul>
                </div>
                <p>
                With over 14 years of experience in product and design, I lead the Product, UX, Research, and Content teams at Nahdi—Saudi Arabia’s #1 pharmacy retail brand. Serving over 100 million guests annually through 1,200+ Nahdi Pharmacy stores, a fast-growing digital platform, and our expanding network of Nahdi Care Clinics, I focus on designing seamless omnichannel experiences across eCommerce, healthcare, and in-store services. My work contributes to over 3 billion SAR in online revenue, driven by a strong foundation in strategy, empathy, and innovation—delivering meaningful impact for both guests and the business.
                </p>
                <div className="btn-sec">
                  <button className="btn" onClick={() => {
                    window.location.replace('#contact-us');
                  }}>let's chat</button>
                  <button
                    className="btn"
                    onClick={() => {
                      window.scrollTo(0, 5580);
                    }}
                  >
                    Get 1-1 mentorship
                  </button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Banner;
